module.exports = __webpack_public_path__ + "static/media/signaturesSchemesEmpty.5cdf77d5.svg";